<template>
    <div class="opinion-scale"  :style="inputStyles">
        <label :for="`option-${option}`" v-for="option in options" :key="option"
               class="option tw-text-center"
               :class="{ 'selected': selected == option }"
               :style="{
                        borderColor: inputStyles.color,
                        backgroundColor: (option == selected) ? convertHexToRGBA(inputStyles.color, 15) : convertHexToRGBA(inputStyles.color, 5),
                        boxShadow: (option == selected) ? `${inputStyles.color} 0px 0px 0px 2px` : 'none'
                   }"
        >
            <input type="radio"
                   :id="`option-${option}`"
                   :required="config.required"
                   :value="option"
                   v-model="selected"
                   class="tw-hidden"
                   @input="onAnswerInput"
            >
            <span :style="{ color: inputStyles.color }">{{ option }}</span>
        </label>
        <!--
        <div class="tw-flex tw-justify-between">
            <span :style="inputStyles">{{ config.min_label }}</span>
            <span :style="inputStyles">{{ config.max_label }}</span>
        </div>
        -->
    </div>
</template>

<script>

export default {
    name: 'QuestionOpinionScale',
    props: {
        value: {
            default: undefined
        },
        inputStyles: {
            type: Object,
        },
        readonly: {
            type: Boolean,
            default: false
        },
        config: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            selected: null
        }
    },
    computed: {
        options() {
            return [...Array(parseInt((this.config.max_value ?? 5) + (1 - this.config.start_from_zero) )).keys()].map(i => this.config.start_from_zero ? i + 1 : i );
        }
    },
    watch: {
        value: {
            handler(value) {
                this.selected = this.value;
                this.answer(value);
            },
            immediate: true
        },
    },
    methods: {
        onAnswerInput(event) {
            this.answer(event.target.value);
        },
        answer(value) {
            this.$emit('answer', {
                value: value,
                valid: true,
            });
        }
    },
}
</script>
